const Backbone = require('lib/backbone')
const RelatedList = require('./related_list')
const RelatedModel = require('./related_model')
const MetaList = require('./meta_list')
const InterestList = require('./interest_list')
const RoleList = require('./role_list')
const SavedImage = require('./saved_image')
const LocationList = require('./location_list')
const DomainList = require('./domain_list')
const AppList = require('./app_list')
const LinkList = require('./link_list')
const Portfolio = require('./portfolio')
const Store = require('./store')
const Testimonials = require('./testimonials')
const Spotlight = require('./spotlight')

// keys should be in alphabetical order
const UserRelations = [
    {
        key: 'actions',
        type: Backbone.One,
        relatedModel: RelatedModel.extend({ id: 'actions' }),
    },
    {
        key: 'address',
        type: Backbone.One,
        relatedModel: RelatedModel.extend({ id: 'address' }),
    },
    {
        key: 'apps',
        type: Backbone.Many,
        collectionType: AppList,
    },
    {
        key: 'contact',
        type: Backbone.One,
        relatedModel: RelatedModel.extend({ id: 'contact' }),
    },
    {
        key: 'contact_me',
        type: Backbone.One,
        relatedModel: RelatedModel.extend({ id: 'contact_me' }),
    },
    {
        key: 'email_channels',
        type: Backbone.One,
        relatedModel: RelatedModel.extend({ id: 'email_channels' }),
    },
    {
        key: 'flags',
        type: Backbone.One,
        relatedModel: RelatedModel.extend({ id: 'flags' }),
    },
    {
        key: 'images',
        type: Backbone.Many,
        collectionType: RelatedList.extend({
            id: 'images',
            model: SavedImage,
        }),
    },
    {
        key: 'interests',
        type: Backbone.Many,
        collectionType: InterestList,
    },
    {
        key: 'jobs',
        type: Backbone.Many,
        collectionType: MetaList.extend({ id: 'jobs' }),
    },
    {
        key: 'layout',
        type: Backbone.One,
        relatedModel: RelatedModel.extend({ id: 'layout' }),
    },
    {
        key: 'links',
        type: Backbone.Many,
        collectionType: LinkList,
    },
    {
        key: 'locations',
        type: Backbone.Many,
        collectionType: LocationList,
    },
    {
        key: 'mapped_domains',
        type: Backbone.Many,
        collectionType: DomainList,
    },
    {
        key: 'portfolio',
        type: Backbone.Many,
        collectionType: Portfolio,
    },
    {
        key: 'roles',
        type: Backbone.Many,
        collectionType: RoleList,
    },
    {
        key: 'schools',
        type: Backbone.Many,
        collectionType: MetaList.extend({ id: 'schools' }),
    },
    {
        key: 'slack_teams',
        type: Backbone.Many,
        collectionType: RelatedList.extend({ id: 'slack_teams' }),
    },
    {
        key: 'spotlight',
        type: Backbone.One,
        relatedModel: Spotlight.extend({ id: 'spotlight' }),
    },
    {
        key: 'spotlight_trial',
        type: Backbone.One,
        relatedModel: Spotlight.extend({ id: 'spotlight_trial' }),
    },
    {
        key: 'store',
        type: Backbone.One,
        relatedModel: Store,
    },
    {
        key: 'tags',
        type: Backbone.Many,
        collectionType: MetaList.extend({ id: 'tags' }),
    },
    {
        key: 'testimonials',
        type: Backbone.One,
        relatedModel: Testimonials,
    },
    {
        key: 'video',
        type: Backbone.One,
        relatedModel: RelatedModel.extend({ id: 'video' }),
    },
]


module.exports = UserRelations
